import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import CALL from "_DatabaseFunctions/cloudCalls";
import DB from "_DatabaseFunctions/directConnect";

import { Button, Box } from "@mui/material";

import ModalComp from "app/Components/Modals/ModalTemplate";

interface RootState {
  user: {
    user: {
      uid: string;
    };
  };
}

interface RequestData {
  id: string;
  senderId: string;
  senderName: string;
  gameName: string;
  receiverId: string;
  gameId: string;
}

interface ModalDets {
  open: boolean;
  status: string;
  reqData: RequestData;
}

function RequestsModal({ dets }: { dets: ModalDets }) {
  const user = useSelector((state: RootState) => state.user.user);
  const { reqData } = dets;
  const [open, setShow] = useState(false);
  const [modalData, setModalData] = useState<{
    status?: string;
    title?: string;
    msg?: string;
    type?: string;
    action?: string;
  }>({});

  useEffect(() => {
    if (dets.open === true) {
      setShow(true);
      renderModalInfo(dets.status);
    }
  }, [dets]);

  const acceptRequest = () => {
    DB.acceptRequest(reqData.id);
    DB.moveToWaitlist(reqData);
    DB.sendAcceptNotification(
      reqData.senderId,
      user.uid,
      reqData.gameName,
      reqData.gameId,
    );
    CALL.sendAcceptedEmail(reqData.senderId, reqData.gameName);
  };

  const declineRequest = async () => {
    await DB.deleteRequest(reqData.id);
    await DB.sendDeclineNotification(reqData);
    await CALL.sendDeclinedEmail(reqData.senderId, reqData.gameName);
  };

  const renderModalInfo = (status: string) => {
    switch (status) {
      case "acceptRequest":
        setModalData({
          status,
          title: "Accept Request",
          msg: `Accept ${reqData.senderName}'s Request to Join ${reqData.gameName}?`,
          type: "info",
        });
        break;
      case "declineRequest":
        setModalData({
          status,
          title: "Decline Request",
          msg: `Decline ${reqData.senderName}'s Request to Join ${reqData.gameName}?`,
          type: "info",
        });
        break;
      default:
        console.log("case not handled");
        break;
    }
  };

  const modalChildren = () => {
    if (
      modalData.status === "acceptRequest" ||
      modalData.status === "declineRequest"
    ) {
      const ChildMap: Record<string, { callback: () => void | Promise<void>; msg: string }> = {
        acceptRequest: {
          callback: acceptRequest,
          msg: `Request Accepted. ${reqData.senderName} is Now on the Waitlist`,
        },
        declineRequest: {
          callback: declineRequest,
          msg: `Request Declined`,
        },
      };

      const { callback, msg } = ChildMap[modalData.status];
      return (
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', mt: 2 }}>
          <Button
            variant="contained"
            color="success"
            onClick={() => {
              callback();
              setModalData({
                type: "success",
                title: "Success",
                msg,
              });
            }}
            sx={{
              borderRadius: '20px',
              px: 3,
              py: 1,
              fontWeight: 600,
              textTransform: 'none',
              minWidth: 100,
            }}
          >
            Confirm
          </Button>
          <Button 
            variant="contained"
            color="error"
            onClick={() => setShow(false)}
            sx={{
              borderRadius: '20px',
              px: 3,
              py: 1,
              fontWeight: 600,
              textTransform: 'none',
              minWidth: 100,
            }}
          >
            Cancel
          </Button>
        </Box>
      );
    }
  };

  return (
    <ModalComp
      title={modalData.title}
      modalType={modalData.type}
      msg={modalData.msg}
      show={open}
      onClose={() => setShow(false)}
      action={modalData.action}
    >
      {modalChildren()}
    </ModalComp>
  );
}

export default RequestsModal;
